import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconMerged: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconMerged"><Circle cx="6" cy="6" r="2.25" stroke="currentColor" strokeWidth="1.5"/><Circle cx="6" cy="18" r="2.25" stroke="currentColor" strokeWidth="1.5"/><Circle cx="18" cy="18" r="2.25" stroke="currentColor" strokeWidth="1.5"/><Path d="M6 8.25V15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M8.5 6H15C16.6569 6 18 7.34315 18 9V15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconMerged;
